export default __webpack_public_path__ + "static/media/pic_Build.5e3e062d.svg";